import { SHOT_BACKGROUND_TYPES } from '../../features/video-reformatting/constants';
import ShotBackground from './ShotBackground';
import { isNotNil } from '../../util/object';

export default class ShotBackgroundCollection {
  _shotBackgrounds = new Set();
  _types = new Set();
  _values = new Set();

  get shotBackgrounds() {
    return this._shotBackgrounds;
  }

  get types() {
    return this._types;
  }

  get values() {
    return this._values;
  }

  /* Convenient methods */
  addShotBackground(shotBackground) {
    if (!ShotBackground.isValidShotBackground(shotBackground)) return;
    if (this.has(shotBackground)) return;

    this._shotBackgrounds.add(shotBackground);
    this._types.add(shotBackground.type);

    if (isNotNil(shotBackground.value)) {
      this._values.add(shotBackground.value);
    }
  }

  get(index) {
    return [...this._shotBackgrounds][index];
  }

  has(shotBackground) {
    if (!ShotBackground.isValidShotBackground(shotBackground)) return false;
    return [...this._shotBackgrounds].some((inCollectionShotBackground) =>
      inCollectionShotBackground.equals(shotBackground),
    );
  }

  isEmpty() {
    return this._types.size === 0;
  }

  /**
   * Checks if object is an instance of ShotGroupMeta
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isShotBackgroundCollection(inputObject) {
    return inputObject instanceof ShotBackgroundCollection;
  }

  static hasMixedTypes(inputObject) {
    if (!ShotBackgroundCollection.isShotBackgroundCollection(inputObject)) {
      return false;
    }

    // check if see if there are multiple type of shot backgrounds
    return inputObject.types.size > 1;
  }

  static hasMixedColorValues(inputObject) {
    if (!ShotBackgroundCollection.isShotBackgroundCollection(inputObject)) {
      return false;
    }

    // check if see if there are multiple type of shot backgrounds
    if (ShotBackgroundCollection.hasMixedTypes(inputObject)) return false;

    // check if FILL is selected
    if (!inputObject.types.has(SHOT_BACKGROUND_TYPES.FILL)) return false;

    // check if see if there are multiple values
    return inputObject.values.size > 1;
  }
}
